
  import {
    
    useGetFarmerTaskDetailsQuery,
  } from "features/onboarding/users/farmer/farmerApiSlice";
  import React,{useState,useEffect} from "react";
  const TaskDetails = ({
    orgId,
    refetch,
    RoleAcessParams,
    currentUser,farmers
  }) => {
   
  
    const { data: TaskDetails } = useGetFarmerTaskDetailsQuery({
      
    });
  
  
    const [showError, setError] = useState(false);
    const [taskDetails, setTaskDetails] = useState([]);
    const [activeTabs, setActiveTab] = useState("failed");

  
   
    useEffect(() => {
      if (TaskDetails) {
        setTaskDetails(TaskDetails?.data);
      }
    }, [TaskDetails]);
  
 
    
    const handleTabClick = (taskId, tab) => {
      setActiveTab((prevTabs) => ({
        ...prevTabs,
        [taskId]: tab,
      }));
    };
    const tableHeaderStyle = {
      padding: "8px",
      textAlign: "left",
      backgroundColor: "#f1f1f1",
      borderBottom: "1px solid #ddd",
    };
  
    const tableCellStyle = {
      padding: "8px",
      borderBottom: "1px solid #ddd",
    };
    const convertToCSV = (data) => {
      const header = [
        "first_name",
        "last_name",
        "phone_number",
        "DOB",
        "gender",
        "pincode",
        "address",
        "error",
      ];
      const rows = data.map((user) => [
        user.first_name,
        user.last_name,
        user.phone_number,
        user.DOB,
        user.gender,
        user.pincode,
        user.address,
        user.error,
      ]);
  
      const csvContent = [
        header.join(","), // Add the header row
        ...rows.map((row) => row.join(",")), // Add data rows
      ]
        .map((row) => row.replace(/(\r\n|\n|\r)/gm, "")) // Clean up any new lines
        .join("\n");
  
      return csvContent;
    };
    const downloadCSV = (data) => {
        const csvContent = convertToCSV(data);
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
    
        link.setAttribute("href", url);
        link.setAttribute("download", "failed_users.csv");
        link.click();
      };
   
    return (
      <>
       
      
       
            <div style={{fontFamily: "Arial" }}>
              {taskDetails?.length ? (
                taskDetails.map((task) => {
                  const activeTab = activeTabs[task.id] || "failed"; // Default to "failed"
                  return (
                    <div
                      key={task.id}
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        padding: "16px",
                        marginBottom: "16px",
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      <div>
                        <p>
                          <strong>Status :</strong>{" "}
                          <span style={{ color: "green" }}>{task.status}</span>
                        </p>
                        <p>
                          <strong>Created At:</strong>{" "}
                          {new Date(task.created_at).toLocaleString()}
                        </p>
                      </div>
  
                      <div style={{ marginTop: "16px" }}>
                        <div style={{ display: "flex", gap: "16px" }}>
                          <button
                            onClick={() => handleTabClick(task.id, "failed")}
                            style={{
                              padding: "10px 20px",
  
                              color: activeTab === "failed" ? "orange" : "black",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                          >
                            Failed Users
                          </button>
                          <button
                            onClick={() => handleTabClick(task.id, "completed")}
                            style={{
                              padding: "10px 20px",
  
                              color:
                                activeTab === "completed" ? "orange" : "black",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                          >
                            Completed Users
                          </button>
                        </div>
  
                        {activeTab === "failed" ? (
                          task?.results?.failed_users?.length > 0 ? (
                            <div
                              style={{
                                marginTop: "16px",
                                maxHeight: "300px",
                                overflowY: "auto",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                              }}
                            >
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th style={tableHeaderStyle}>Full Name</th>
                                    <th style={tableHeaderStyle}>Phone Number</th>
                                    <th style={tableHeaderStyle}>DOB</th>
                                    <th style={tableHeaderStyle}>Gender</th>
                                    <th style={tableHeaderStyle}>Pincode</th>
                                    <th style={tableHeaderStyle}>Error</th>
                                    <th style={tableHeaderStyle}>
                                      <button
                                        onClick={() =>
                                          downloadCSV(task?.results?.failed_users)
                                        }
                                        style={{
                                          backgroundColor: "#FFA500", // Orange color
                                          color: "#fff", // White text
                                          border: "none",
                                          borderRadius: "4px",
                                          padding: "5px 10px", // Small size
                                          cursor: "pointer",
                                          fontSize: "12px",
                                        }}
                                        onMouseOver={(e) =>
                                          (e.target.style.backgroundColor =
                                            "#FF8C00")
                                        } // Slightly darker orange on hover
                                        onMouseOut={(e) =>
                                          (e.target.style.backgroundColor =
                                            "#FFA500")
                                        }
                                      >
                                        Download
                                      </button>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {task?.results?.failed_users?.map(
                                    (user, index) => {
                                      //             const jsonString =
  
                                      // "{'DOB': [\"time data '-2003' does not match format '%d-%m-%Y'\"]}"
                                      // const obj = JSON.parse(jsonString);
                                      // console.log("obje",obj)
  
                                      return (
                                        <tr key={index}>
                                          <td style={tableCellStyle}>
                                            {user.full_name}
                                          </td>
                                          <td style={tableCellStyle}>
                                            {user.phone_number}
                                          </td>
                                          <td style={tableCellStyle}>
                                            {user.DOB}
                                          </td>
                                          <td style={tableCellStyle}>
                                            {user.gender}
                                          </td>
                                          <td style={tableCellStyle}>
                                            {user.pincode}
                                          </td>
                                          <td style={tableCellStyle}>
                                            {user.error}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <p style={{ marginTop: "16px", color: "gray" }}>
                              No failed users.
                            </p>
                          )
                        ) : task?.results?.created_users?.length > 0 ? (
                          <div
                            style={{
                              marginTop: "16px",
                              maxHeight: "300px",
                              overflowY: "auto",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                            }}
                          >
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                              }}
                            >
                              <thead>
                                <tr>
                                  <th style={tableHeaderStyle}>Full Name</th>
                                  <th style={tableHeaderStyle}>Phone Number</th>
                                  <th style={tableHeaderStyle}>DOB</th>
                                  <th style={tableHeaderStyle}>Gender</th>
                                  <th style={tableHeaderStyle}>Pincode</th>
                                  <th style={tableHeaderStyle}>Address</th>
                                </tr>
                              </thead>
                              <tbody>
                                {task?.results?.created_users?.map(
                                  (user, index) => (
                                    <tr key={index}>
                                      <td style={tableCellStyle}>
                                        {user.full_name}
                                      </td>
                                      <td style={tableCellStyle}>
                                        {user.phone_number}
                                      </td>
                                      <td style={tableCellStyle}>{user.DOB}</td>
                                      <td style={tableCellStyle}>
                                        {user.gender}
                                      </td>
                                      <td style={tableCellStyle}>
                                        {user.pincode}
                                      </td>
                                      <td style={tableCellStyle}>
                                        {user.address}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <p style={{ marginTop: "16px", color: "gray" }}>
                            No completed users.
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No task details available.</p>
              )}
            </div>
      
      </>
    );
  };
  export default TaskDetails;
  